import { render } from "./StartGameBoxId.vue?vue&type=template&id=c05f6b22"
import script from "./StartGameBoxId.vue?vue&type=script&lang=js"
export * from "./StartGameBoxId.vue?vue&type=script&lang=js"

import "./StartGameBoxId.vue?vue&type=style&index=0&id=c05f6b22&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__